<div mat-dialog-title [class]="'dialog-' + data.type" class="dialogContainer">
    <label class="labelTitle">
        {{data.title | translate}}
    </label>
    <button type="button" class="btn-close btn-close-white shadow-none p-0" aria-label="Close dialog"
        [mat-dialog-close]></button>
</div>

<mat-dialog-content class="dialogContent">
    <div class="dialogMessageText">{{data.message | translate}}</div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialogActionsBtns">
    <button mat-raised-button [mat-dialog-close] (click)="onConfirmClick()" [ngClass]="{
            'mat-warn': data.type === 'error',
            'mat-primary': data.type !== 'error'
        }">{{'OK_BTN' | translate}}</button>
</mat-dialog-actions>